var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medical-analyses-report" },
    [
      _c(
        "div",
        { staticClass: "layout documents-report" },
        [
          _c("div", { staticClass: "layout-header" }, [
            _c("div", { staticClass: "layout-title" }, [
              _vm._v("Отчёт по анализам сотрудников"),
            ]),
            _c("div", { staticClass: "layout-header-actions" }, [
              _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("c-button", {
                    attrs: {
                      size: "small",
                      icon: {
                        icon: "bookmark",
                        activeColor: "white",
                      },
                      tooltip: {
                        text: "Добавить в закладки",
                        activeText: "Убрать из закладок",
                      },
                      "active-color": "blue",
                      active: _vm.bookmark,
                    },
                    on: {
                      click: function ($event) {
                        _vm.bookmark = !_vm.bookmark
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("export-google-forms-action", {
                    ref: "googleForm",
                    attrs: { "table-name": "medical_analyses" },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("medical-analyses-report-filters", {
            ref: "filters",
            on: { inited: _vm.onFiltersInit, apply: _vm.applyFilters },
          }),
          _c("medical-analyses-report-table", {
            ref: "table",
            attrs: {
              inited: _vm.inited,
              loading: _vm.loading,
              workers: _vm.workers,
              filters: _vm.filtersChangesTableRows,
            },
            on: { nextPage: _vm.nextPage },
          }),
        ],
        1
      ),
      _c("to-top-button", { attrs: { element: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }